// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TCheckPriceRequest, TCheckPriceModel, IMappers, TCheckPriceResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV2CheckPriceResponse } from '../../entities/response/V2CheckPriceResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCheckPriceModel(parameters: TCheckPriceRequest): TCheckPriceModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v2/check-price/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICheckPriceOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCheckPriceRequest;
}

export async function fetchCheckPrice<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICheckPriceOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCheckPriceResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCheckPriceModel(parameters),
    config,
  )) as FetchResponse<TCheckPriceResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV2CheckPriceResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCheckPriceResponse>;
}
